import { render, staticRenderFns } from "./quantity-scale.vue?vue&type=template&id=39666133&scoped=true"
import script from "./quantity-scale.vue?vue&type=script&lang=js"
export * from "./quantity-scale.vue?vue&type=script&lang=js"
import style0 from "./quantity-scale.vue?vue&type=style&index=0&id=39666133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39666133",
  null
  
)

export default component.exports